import { applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import log from '../middleware/log';
var middleware = [thunk];
if (process.env.NODE_ENV !== 'production') {
  middleware.push(log);
}
export default applyMiddleware(...middleware);